import {DomainEvent} from './DomainEvent';
import {DeletedEntity} from '../resources/DeletedEntity';

export class MatchEventDeleted extends DomainEvent<DeletedEntity> {}
